import { Group, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { MAIL_CATEGORIES, type MailCategory } from 'modules/Mails/types';
import { useUpdateMail } from 'shared/hooks/use-update-mail';
import { AddCategoryMenu } from './AddCategoryMenu';
import { CategoryBadge } from './CategoryBadge';
import { useThreadMessage } from './useThreadMessage';

export const ThreadMessageCategories = () => {
  const { t } = useTranslation();
  const { mail } = useThreadMessage();
  const { updateMail } = useUpdateMail();

  const remainingCategories = MAIL_CATEGORIES.filter(
    category => !mail.categories.includes(category),
  );

  const applyCategories = (next: MailCategory[]) => {
    updateMail({ id: mail.id, categories: next });
  };

  const handleRemove = (toRemove: MailCategory) => {
    applyCategories(mail.categories.filter(category => category !== toRemove));
  };

  const handleAdd = (toAdd: MailCategory) => {
    applyCategories([...mail.categories, toAdd]);
  };

  return (
    <Group px="space4" py="space2" gap="space2" wrap="wrap" bg="gray.0">
      <Text size="xs" tt="uppercase" fw={600} c="dimmed">
        {t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.CATEGORIES_LABEL)}
      </Text>

      {mail.categories.map(category => (
        <CategoryBadge key={category} category={category} onRemove={() => handleRemove(category)} />
      ))}

      <AddCategoryMenu availableCategories={remainingCategories} onAdd={handleAdd} />
    </Group>
  );
};
